import { BottomSheet, Text, type UseModalState } from "@clipboard-health/ui-components";
import { DialogContent } from "@mui/material";
import { BottomSheetHeader } from "@src/appV2/redesign/components/BottomSheetHeader";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { IllustrationListItem } from "@src/appV2/redesign/components/IllustrationListItem";

export interface HowGettingPaidWorksBottomSheetProps {
  modalState: UseModalState;
}

export function HowGettingPaidWorksBottomSheet(props: HowGettingPaidWorksBottomSheetProps) {
  const { modalState } = props;

  return (
    <BottomSheet
      modalState={modalState}
      header={<BottomSheetHeader onClose={modalState.closeModal} />}
      footer={
        <DialogFooter orientation="vertical">
          <Button fullWidth onClick={modalState.closeModal}>
            Got it!
          </Button>
        </DialogFooter>
      }
    >
      <DialogContent sx={(theme) => ({ paddingX: theme.spacing(5) })}>
        <Text semibold variant="h4" sx={(theme) => ({ marginBottom: theme.spacing(9) })}>
          How getting paid works
        </Text>
        <IllustrationListItem
          divider
          illustrationType="calendar-gray-small"
          title="Book a shift"
          description="Browse available shifts and book one that fits your schedule."
        />
        <IllustrationListItem
          divider
          illustrationType="location-gray-small"
          title="Clock in"
          description="Once you arrive at the workplace, use the app to clock in before your shift starts."
        />
        <IllustrationListItem
          divider
          illustrationType="clock-gray-small"
          title="Clock out"
          description="Clock out when your shift ends — that's it."
        />
        <IllustrationListItem
          illustrationType="instant-pay-gray-small"
          title="Receive your payout"
          description="Get paid in minutes with InstantPay, or 1-3 days with Standard payouts."
        />
      </DialogContent>
    </BottomSheet>
  );
}
